import { render, staticRenderFns } from "./IncluirPedidoLojaDrp.vue?vue&type=template&id=5ba704ec&scoped=true"
import script from "./IncluirPedidoLojaDrp.vue?vue&type=script&lang=js"
export * from "./IncluirPedidoLojaDrp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba704ec",
  null
  
)

export default component.exports